import { render, staticRenderFns } from "./NurseMain.vue?vue&type=template&id=715bdcfe&"
import script from "./NurseMain.vue?vue&type=script&lang=js&"
export * from "./NurseMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports